<button mat-raised-button *appRole="['TiposFolio.Crear']" color="primary" [disabled]="true" [routerLink]="['/tiposfolio']">
    <mat-icon>add</mat-icon>
    Nueva tipo folio
</button>
